var _process$env$VUE_APP_;
var config = {
  mpmEnv: import.meta.env.MPM_ENV,
  mpmBackendUrl: import.meta.env.MPM_BACKEND_URL,
  mpmBackendUrlExternal: (_process$env$VUE_APP_ = process.env.VUE_APP_MPM_BACKEND_URL_EXTERNAL) !== null && _process$env$VUE_APP_ !== void 0 ? _process$env$VUE_APP_ : import.meta.env.MPM_BACKEND_URL
};
export { config };